import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import LiveChapterTable from './LiveChapter';
const LiveChapter = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Live Chapter' parent='Live Chapter'  />
      <Container fluid={true}>
        <Row>
          <LiveChapterTable  />
        </Row>
      </Container>
    </Fragment>
  );
};

export default LiveChapter;
